import {
  IFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import SureStepBuy_1 from "../sureSteps/step_1";
import SureStepBuy_2 from "../sureSteps/step_2";
import SureStepBuy_3 from "../sureSteps/step_3";

const getShureSteps = (
  data: IFillDataWizardBuy,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void
) => {
  // если знает что хочет преобрести

  return [
    <SureStepBuy_1
      data={data.freeComment}
      onChange={handleChangeDataString}
      onReset={onReset}
    />,
    <SureStepBuy_2 />,
    <SureStepBuy_3 />,
  ];
};

export default getShureSteps;
